import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import { QueryClient, QueryClientProvider } from "react-query";
import { checkAdminStatus } from "./apis/Network";
import General from "./modules/GeneralComponent/General";
import ROUTES from "./router/NewRoutes";
import "render-smooth-image-react/build/style.css";
import "react-toastify/dist/ReactToastify.css";
import "leaflet-draw/dist/leaflet.draw.css";
import "react-leaflet-fullscreen/styles.css";
import "react-multi-carousel/lib/styles.css";
// import i18n from "locales";
import { t } from "i18next";
import { useTransition } from "react";
import { useTranslation } from "react-i18next";
import i18n from "locales";

const queryClient = new QueryClient();

function App() {
  const { authorization } = useSelector((state) => state.auth);
  const { lang, dir } = useSelector((state) => state.localization);
  console.log("🚀 ~ App ~ dir:", dir);
  console.log("🚀 ~ App ~ lang:", lang);

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (authorization && authorization.token) {
      checkAdminStatus(
        (res) => {
          if (res.success) {
            if (!res.data) {
              navigate(ROUTES.LOGOUT, { replace: true });
            }
          }
        },
        (res) => {}
      );
    }
    if (authorization?.roles?.includes(20)) {
      i18n.changeLanguage("ar");
    } else {
      i18n.changeLanguage("en");
    }
  }, [location, navigate, authorization]);

  useEffect(() => {
    document.documentElement.setAttribute("lang", lang);
    document.documentElement.setAttribute("dir", dir);
  }, [lang]);

  // useEffect(() => {
  //   if (lang === "ar") {
  //     document.documentElement.setAttribute("lang", lang || "en");
  //     document.documentElement.setAttribute("dir", dir || "ar");
  //   } else {
  //     document.documentElement.setAttribute("lang", "en");
  //     document.documentElement.setAttribute("dir", "ltr");
  //   }
  // }, [language]);

  return (
    <QueryClientProvider client={queryClient}>
      <ToastContainer />
      <General />
    </QueryClientProvider>
  );
}

export default App;
